// HelpAssistant/segmentPanelObstruction.js
//
// BUG-wheel-view-e4bc4c / BUG-wheel-view-6ae0ed (Kelly, QA-136 re-audit,
// 2026-08-13, C:\iYuga\qa-notes\KELLY-REAUDIT-MISSED-2026-08-13.md): the
// persistent Help FAB (fixed, bottom-right, z-index 13000 — HelpLauncher.jsx)
// was measured overlapping the open segment's own caption/title on the mobile
// View-Wheel page ("CASTOR OIL + CASTOR OIL WRAP", frames 34/42/86).
//
// WHY THIS IS A DIFFERENT FIX SHAPE THAN THE CONSENT-BANNER OBSTRUCTION
// (useConsentObstruction.js): that mechanism reads the banner's own
// getBoundingClientRect().height and treats it as "space occupied at the
// viewport's bottom edge" — valid because the banner is bottom-docked. The
// mobile open-segment panel (SegmentView, mounted by
// pages/ViewWheel/MobileView/index.jsx) is NOT bottom-anchored: its
// MainWrapper is `position: relative`, laid out IN-FLOW below the wheel
// (styles.js), so it scrolls under the fixed FAB's corner rather than sitting
// pinned beneath it. A height-clamp is the wrong shape here; the FAB must
// simply step aside while the panel is open, matching the ALREADY-ESTABLISHED
// convention on this exact page: MobileView/index.jsx already hides its OWN
// other bottom-corner control (ToggleLabelIconContainer, the show/hide-labels
// icon) with `{!openSegmentList && (...)}` for precisely this reason. This
// module extends that same suppression to the Help FAB, which MobileView
// cannot gate directly because HelpAssistant is mounted once at the app root
// (App.js), not inside ViewWheel.
//
// The contract is a single boolean DOM signal on <body> — deterministic on
// the page's own open/closed intent, not a race-prone rect-overlap guess.

/** The data-* attribute name (HTML form: data-segment-panel-open). */
export const SEGMENT_PANEL_OPEN_ATTR = "data-segment-panel-open";

/** The matching camelCase key on `element.dataset`. */
export const SEGMENT_PANEL_OPEN_DATASET_KEY = "segmentPanelOpen";

/**
 * Called by the mobile View-Wheel page whenever its own `openSegmentList`
 * state changes. Pure DOM write, never throws (SSR / detached-document safe).
 */
export const setSegmentPanelOpen = (open) => {
  try {
    if (!document.body) return;
    if (open) {
      document.body.setAttribute(SEGMENT_PANEL_OPEN_ATTR, "true");
    } else {
      document.body.removeAttribute(SEGMENT_PANEL_OPEN_ATTR);
    }
  } catch (e) {
    // no-op — never let a DOM write break the page
  }
};

/** Read the current flag synchronously. Never throws. */
export const readSegmentPanelOpen = () => {
  try {
    return document.body?.dataset?.[SEGMENT_PANEL_OPEN_DATASET_KEY] === "true";
  } catch (e) {
    return false;
  }
};
